
import {
  INIT_REPORT_INFO,
  REQUEST_REPORT_START,
  REQUEST_REPORT_SUCCESS,
  REQUEST_REPORT_FAIL,

  CREATE_REPORT_START,
  CREATE_REPORT_SUCCESS,
  CREATE_REPORT_FAIL,
} from '../actions/report';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_REPORT_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_REPORT_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_REPORT_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case CREATE_REPORT_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case CREATE_REPORT_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case CREATE_REPORT_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_REPORT_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
